
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.667 2.667H12V1.333h-1.333v1.334H5.333V1.333H4v1.334h-.667c-.74 0-1.326.6-1.326 1.333L2 13.333c0 .734.593 1.334 1.333 1.334h9.334c.733 0 1.333-.6 1.333-1.334V4c0-.733-.6-1.333-1.333-1.333zm0 10.666H3.333V6.667h9.334v6.666zm0-8H3.333V4h9.334v1.333zM6 9.333H4.667V8H6v1.333zm2.667 0H7.333V8h1.334v1.333zm2.666 0H10V8h1.333v1.333zM6 12H4.667v-1.333H6V12zm2.667 0H7.333v-1.333h1.334V12zm2.666 0H10v-1.333h1.333V12z","fill":"currentColor"}})])
          )
        }
      }
    